import {
  FetchFolioDocumentOriginalResponse,
  FolioDocumentRef,
  FolioDocumentSource,
  FolioDocumentUploadResponse,
} from "@/types/folio/folio-document"
import { TripRef } from "@/types/trip"

import { BaseApi } from "./base-api"

export class FolioDocumentApi extends BaseApi {
  async upload(
    tripRef: TripRef | null | undefined,
    source: FolioDocumentSource,
    files: File[]
  ): Promise<FolioDocumentUploadResponse> {
    const formData = new FormData()
    files.forEach((file, index) => {
      formData.append(`files[${index}]`, file)
    })
    if (tripRef) formData.append("trip_ref", tripRef)
    if (source) formData.append("source", source)

    return await this.post<FolioDocumentUploadResponse>(
      "/api/folio_documents",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
  }

  async fetchOriginalContent(
    ref: FolioDocumentRef
  ): Promise<{ content: string; contentType: string }> {
    const response = await this.get<FetchFolioDocumentOriginalResponse>(
      `/api/folio_documents/original_content/${ref}`
    )
    return { content: response.content, contentType: response.content_type }
  }
}
